<template>
  <b-row>
    <b-col>
      <divisoria-descricao
        :titulo="'Informações Gerais'"
        :descricao="'Adicione as informações gerais desta empresa'"
      />
      <b-row>
        <b-col cols="2">
          <b-form-group label="Tipo de inscrição">
            <b-select
              ref="tipoInscricao"
              v-model="empresa.tipoInscricao"
              :options="['CNPJ','CPF','CEI','CAEPF']"
              @change="empresa.cadastroFederal = '', incricaoExist = false"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <cnpj-input
            v-if="empresa.tipoInscricao === 'CNPJ'"
            v-model="empresa.cadastroFederal"
            :incricao-exist="incricaoExist"
            :msg-erro="msgErro"
            @dados-navegacao="alimentarDadosDoCNPJ"
            @input="validaLogin"
          />
          <b-form-group
            v-else
            label="Inscrição"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="'Inscrição'"
            >
              <masked-input
                ref="cadastroFederal"
                v-model="empresa.cadastroFederal"
                :class="{'is-invalid' : errors.length > 0}"
                :mask="mascaraCadFederal"
                class="form-control"
                @input="validaLogin"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="errors.length == 0 && (!empresa.cadastroFederal || empresa.cadastroFederal === '') && msgErro"
                class="text-danger"
              >
                O campo 'Inscrição' é obrigatório
              </small>
              <span
                v-if="incricaoExist"
                style="color: red; font-size: 12px;"
              > Já existe outra empresa cadastrada com o mesmo número de inscrição </span>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Razão Social">
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="'Razão Social'"
            >
              <b-form-input
                v-model="empresa.razaoSocial"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="errors.length == 0 && (!empresa.razaoSocial || empresa.razaoSocial === '') && msgErro"
                class="text-danger"
              >
                O campo 'Razão Social' é obrigatório
              </small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Nome Fantasia">
            <b-form-input v-model="empresa.nomeFantasia" />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <enquadramento-select
            v-model="empresa.enquadramento"
            :require="false"
          />
        </b-col>
        <b-col cols="3">
          <b-form-group label="Código NIRE">
            <b-form-input v-model="empresa.nire" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label="Inscrições Estaduais">
            <inscricao-estadual v-model="empresa.ieItens" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Inscrições Municipais">
            <inscricao-municipal v-model="empresa.imItens" />
          </b-form-group>
        </b-col>
      </b-row>
      <divisoria-descricao
        :titulo="'Informações sobre o CNAE'"
        :descricao="'Cadastro Nacional de Atividades Econômicas (principal e secundárias)'"
      />
      <b-row>
        <b-col cols="12">
          <cnaePrincipal v-model="empresa.cnaePrincipal" />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="CNAE Secundários">
            <cnae-secundario />
          </b-form-group>
        </b-col>
      </b-row>

      <divisoria-descricao
        :titulo="'Informações Detalhadas'"
        :descricao="'Informações adicionais sobre a empresa'"
      />
      <b-row>
        <b-col cols="3">
          <b-form-group label="Início das Atividades">
            <data-input
              id="inicioAtividade"
              v-model="empresa.inicioAtividade"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Cliente Desde">
            <data-input
              id="clienteDesde"
              v-model="empresa.clienteDesde"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Cliente Até">
            <data-input
              id="clienteAte"
              v-model="empresa.clienteAte"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <legend class="bv-no-focus-ring col-form-label pt-0">
              &nbsp;
            </legend>
            <b-checkbox v-model="empresa.clienteFixo">
              <label style="font-size: 1rem">Cliente Fixo</label>
            </b-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <equipe-select
            v-model="empresa.equipe"
          />
        </b-col>
        <b-col cols="3">
          <b-form-group label="Matriz/Filial">
            <b-select
              v-model="empresa.matrizFilial"
              :options="['Matriz', 'Filial']"
              @change="alteraMatriz"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <empresa-select
            ref="matriz"
            v-model="empresa.matriz"
            :disabled="empresa.matrizFilial === 'Matriz'"
            :require="false"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <grupo-empresarial-select
            v-model="empresa.grupoEmpresarial"
            :required="false"
          />
        </b-col>
        <b-col cols="6">
          <servico-select
            v-model="empresa.servicos"
            :multiple="true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <b-form-group label="Honorário">
            <dinheiro-input
              v-model="empresa.honorario"
              :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
            />
          </b-form-group>
        </b-col>
        <b-col cols="9">
          <b-form-group label="Observação">
            <b-input
              v-model="empresa.observacao"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <divisoria-descricao
        :titulo="'Financeiro'"
        :descricao="'Neste grupo, é possível adicionar e visualizar o e-mail para recebimento de boletos e notas fiscais'"
      />

      <b-row>
        <b-col cols="12">
          <email-input
            :value="empresa.emailsBoletosNFs"
            :msg-erro="msgErro"
            :require="true"
            @input="adicionarEmail($event)"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import api from '../../services/api'
// import apiModelos from '@/app/modelo/shared/services/api'

export default {
  nome: 'TabGeral',
  components: {
    ValidationProvider,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    EnquadramentoSelect: () => import('@/shared/components/enquadramento-select/EnquadramentoSelect.vue'),
    GrupoEmpresarialSelect: () => import('@/shared/components/grupoempresarial-select/GrupoEmpresarialSelect.vue'),
    EmpresaSelect: () => import('@/shared/components/empresa-select/EmpresaSelect.vue'),
    EquipeSelect: () => import('@/shared/components/equipe-select/EquipeSelect.vue'),
    ServicoSelect: () => import('@/shared/components/servico-select/ServicoSelect.vue'),
    InscricaoEstadual: () => import('./shared/components/inscricao-estadual/InscricaoEstadual.vue'),
    InscricaoMunicipal: () => import('./shared/components/inscricao-municipal/InscricaoMunicipal.vue'),
    cnaePrincipal: () => import('./shared/components/cnae/CNAE.vue'),
    cnaeSecundario: () => import('./shared/components/cnae-tabela/CNAETabela.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
    cnpjInput: () => import('@/app-modulo/comuns/empresa/shared/components/empresa-cnpj-input/EmpresaCnpjInput.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
  },
  props: {
    msgErro: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      mascaraAplicada: 0,
      incricaoExist: false,
      invalidTags: [],
      duplicateTags: [],
      caixaAlta: false,
    }
  },
  computed: {
    ...mapGetters('empresa', ['empresa']),
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    ...mapActions('empresa', ['setDocumentos', 'setEmpresa', 'setDadosAlterados']),
    adicionarEmail(value) {
      this.empresa.emailsBoletosNFs = value
    },
    mascaraCadFederal() {
      if (this.empresa.tipoInscricao === 'CPF') {
        return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      if (this.empresa.tipoInscricao === 'CEI') {
        return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/]
      }
      if (this.empresa.tipoInscricao === 'CAEPF') {
        return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    alteraMatriz(value) {
      if (value === 'Matriz') {
        this.$set(this.empresa, 'matriz', null)
      }
    },
    alimentarDadosDoCNPJ(value) {
      const empresaDados = value
      if (value.inicioAtividade) {
        const data = new Intl.DateTimeFormat('pt-BR').format(new Date(value.inicioAtividade))
        empresaDados.inicioAtividade = data
      }
      if (value.simplesNacional === 'Sim') {
        empresaDados.enquadramento = { nome: 'Simples Nacional', id: 2 }
      }
      if (this.empresa.id > 0) {
        this.setDadosAlterados(empresaDados)
      } else {
        this.$set(empresaDados, 'departamentos', [])
        this.$set(empresaDados, 'ieItens', [])
        this.$set(empresaDados, 'imItens', [])
        this.setEmpresa(empresaDados)
      }
    },
    validaLogin() {
      const lengtValidacao = this.empresa.cadastroFederal.replaceAll('_', '').length
      if ((this.empresa.tipoInscricao === 'CPF' && lengtValidacao > 13)
        || (this.empresa.tipoInscricao === 'CEI' && lengtValidacao > 14)
        || (this.empresa.tipoInscricao === 'CAEPF' && lengtValidacao > 17)
        || (lengtValidacao > 17) || this.incricaoExist) {
        const decodificado = this.empresa.cadastroFederal.replace('/', '%2F')
        const empresaId = this.empresa.id ? this.empresa.id : 0
        api.existeInscricao(decodificado, empresaId)
          .then(payload => {
            if (payload.data) {
              this.incricaoExist = true
              this.empresa.incricaoExist = true
            } else {
              this.incricaoExist = false
              this.empresa.incricaoExist = false
            }
          })
      }
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.empresa.emailsBoletosNFs = emails
    },
  },
}
</script>
